(function () {
  function init() {
    const btn = document.getElementById('toggle-all-faqs');
    if (!btn) return;

    // Find the FAQ container associated with this button.
    // Your markup is: <p><button...></button></p><div class="faq-container">...</div>
    const p = btn.closest('p');
    let faqContainer = null;

    if (p && p.nextElementSibling && p.nextElementSibling.classList.contains('faq-container')) {
      faqContainer = p.nextElementSibling;
    } else {
      // Fallback if structure changes
      faqContainer = document.querySelector('.faq-container');
    }

    if (!faqContainer) return;

    const faqs = faqContainer.querySelectorAll('details.details');
    if (!faqs.length) return;

    function allOpen() {
      return Array.from(faqs).every(d => d.open);
    }

    function syncLabel() {
      const openNow = allOpen();
      btn.textContent = openNow ? 'Collapse All' : 'Expand All';
      btn.setAttribute('aria-expanded', openNow ? 'true' : 'false');
    }

    function setAll(open) {
      faqs.forEach(d => { d.open = open; });
      syncLabel();
    }

    // Prevent duplicate event binding if init runs multiple times
    if (btn.dataset.scFaqBound === '1') {
      syncLabel();
      return;
    }
    btn.dataset.scFaqBound = '1';

    // Initial label state
    syncLabel();

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      setAll(!allOpen());
    });

    faqs.forEach(d => d.addEventListener('toggle', syncLabel));
  }

  // Run a few times to catch Shopify hydration / late content
  const run = () => init();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 200);
  setTimeout(run, 800);
  setTimeout(run, 2000);
})();
